import React, { Fragment, useEffect, useState } from 'react';
import { translate } from '../../../../Services/translation';
import { post } from '../../../../Services/http';

const MarkAsPaidConfirmationPopup = (props) => {

    const markAsPaid = (customerId, date) => {
        post(`/api/adminecommerce/markaspaid/${customerId}/${date}`)
            .then(() => {
                window.location.reload();
            });
    }

    return (<Fragment>

        <div className='subscription__popup-container'>
            <div className='subscription__popup-content'>
                <div>
                    <div className='add-to-cart-pop-up__close' onClick={() => props.hidePopUp()}></div>
                </div>
                <div className='admin-portal__markaspaid'>
                    <div className='admin-portal__markaspaid-title'>
                        {translate("coptikk.adminportal.markaspaid.confirmationheader")}
                    </div>
                    <div className='admin-portal__markaspaid--items-container'>
                        <div className='bold'>{translate("coptikk.adminportal.markaspaid.confirmationdate")}:</div>
                        <div>{props.date}</div>
                    </div>
                    <div className='admin-portal__markaspaid--items-container'>
                        <div className='bold'>{translate("coptikk.adminportal.markaspaid.confirmationprice")}:</div> 
                        <div>{props.price}</div>
                    </div>
                    <div className='admin-portal__markaspaid--items-container'>
                        <div className='bold'>{translate("coptikk.adminportal.markaspaid.confirmationstatus")}:</div>
                        <div>{props.status}</div>
                    </div>
                    <div className='admin-portal__markaspaid--items-container items_description'>                        
                        <input type='checkbox' checked className='checkbox'></input>                        
                        {translate("coptikk.adminportal.markaspaid.confirmationdescription")}
                    </div>
                    <div className='buttons-wrapper'>
                        <button className={`save active`} onClick={() => markAsPaid(props.customerId, props.date)} >{translate('coptikk.adminportal.markaspaid.confirmationbutton')}</button>
                        <a className='discard' onClick={() => props.hidePopUp()}>{translate('coptikk.adminportal.markaspaid.confirmationcancel')}</a>
                    </div>
                </div>
            </div>
        </div>        
    </Fragment>)
}

export default MarkAsPaidConfirmationPopup;